import { cn } from "@genuin/ui/lib/utils";
import type { SVGIconsProps } from "../type";

export function AppleIcon({ className, ...restProps }: SVGIconsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={cn("gencl:fill-white", className)}
      {...restProps}
    >
      <path
        d="M12.7363 6.98601C13.516 6.98601 14.4932 6.45894 15.0752 5.75617C15.6023 5.11929 15.9866 4.22984 15.9866 3.3404C15.9866 3.21962 15.9756 3.09883 15.9537 3C15.0862 3.03294 14.043 3.58198 13.4171 4.31769C12.923 4.87771 12.4728 5.75617 12.4728 6.65659C12.4728 6.78836 12.4947 6.92013 12.5057 6.96405C12.5606 6.97503 12.6485 6.98601 12.7363 6.98601ZM9.99113 20.2727C11.0563 20.2727 11.5284 19.559 12.8571 19.559C14.2077 19.559 14.5042 20.2508 15.6901 20.2508C16.8541 20.2508 17.6337 19.1747 18.3694 18.1205C19.193 16.9126 19.5334 15.7267 19.5554 15.6718C19.4785 15.6498 17.2494 14.7384 17.2494 12.1799C17.2494 9.9618 19.0063 8.96255 19.1052 8.88568C17.9412 7.21661 16.1733 7.17269 15.6901 7.17269C14.3834 7.17269 13.3183 7.9633 12.6485 7.9633C11.9237 7.9633 10.9684 7.21661 9.8374 7.21661C7.68517 7.21661 5.5 8.99549 5.5 12.3556C5.5 14.4419 6.31258 16.6491 7.31182 18.0766C8.16832 19.2845 8.91501 20.2727 9.99113 20.2727Z"
      />
    </svg>
  );
}